import { TreeNodeDTO } from 'business/models/Models';
import ETreeGroupTypes from 'enums/ETreeGroupTypes';
import EViewType from 'enums/EViewType';

export type SortDirection = 'asc' | 'desc' | null;
export type DetailViewSortColumn =
  | 'fileName'
  | 'datePrepared'
  | 'lastImaged'
  | 'owner'
  | 'dateDispensed';

export enum EDetailViewFilterTypes {
  None,
  Text,
  DateRange,
}

export interface TreeNodesContainerProps {
  treeNodes: any;
  selectedNodes: any[];
  viewType: EViewType;
  groupBy: ETreeGroupTypes;
  nodeClickHandler: (
    link: string,
    node: TreeNodeDTO,
    id: string,
    expanded: boolean,
    inputNodeName: string,
    eventDetail?: number,
  ) => void;
  loadImageIcon;
  selectedExplorerNode: TreeNodeDTO | null;
}

export interface ExplorerNode extends TreeNodeDTO {
  type: string | undefined;
  extra: any | undefined;
  dateDispensed: string;
  lastImaged?: string;
}

export interface NodeCategoryGroup {
  category: string;
  nodes: ExplorerNode[];
}

export const EDetailViewCols = {
  Name: 'fileName',
  DatePrepared: 'datePrepared',
  LastImaged: 'lastImaged',
  Owner: 'owner',
  DateDispensed: 'dateDispensed',
};

export const NODE_ALIGN = 'left';

export const MainHeaderButtonTitles = {
  Support: 'Support',
  Wizard: 'Wizard',
  SearchAll: 'Search All',
  GroupBy: 'Group By',
  SortBy: 'Sort By',
  View: 'View',
} as const;

export interface DetailViewTableProps {
  columns: DetailViewTableColProps[];
}

export interface DetailViewTableColProps {
  key: string;
  label: string;
  align: string;
  className: string;
  sortable: boolean;
  filterType?: EDetailViewFilterTypes;
}

export const DETAIL_VIEW_TABLE_COLS: DetailViewTableProps = {
  columns: [
    {
      key: EDetailViewCols.Name,
      label: 'File Name',
      align: NODE_ALIGN,
      className: 'max-w-[300px] min-w-[300px]',
      sortable: true,
      filterType: EDetailViewFilterTypes.Text,
    },
    {
      key: EDetailViewCols.DatePrepared,
      label: 'Date Created',
      align: NODE_ALIGN,
      className: 'max-w-[200px] min-w-[200px]',
      sortable: true,
      filterType: EDetailViewFilterTypes.DateRange,
    },
    {
      key: EDetailViewCols.LastImaged,
      label: 'Last Imaged',
      align: NODE_ALIGN,
      className: 'max-w-[200px] min-w-[200px]',
      sortable: true,
      filterType: EDetailViewFilterTypes.DateRange,
    },
    {
      key: EDetailViewCols.Owner,
      label: 'Owner',
      align: NODE_ALIGN,
      className: 'w-[160px] min-w-[160px]',
      sortable: true,
      filterType: EDetailViewFilterTypes.Text,
    },
    {
      key: EDetailViewCols.DateDispensed,
      label: 'Date Dispensed',
      align: NODE_ALIGN,
      className: 'max-w-[200px] min-w-[200px]',
      sortable: true,
      filterType: EDetailViewFilterTypes.DateRange,
    },
  ],
};
